import { queryOptions } from '@tanstack/react-query';
import { ProductService } from './services/ProductService';

export const productQueryKeys = {
  all: ['products'] as const,
  variants: () => [...productQueryKeys.all, 'variants'] as const,
  products: (supplyPointId: number) => [...productQueryKeys.all, 'list', supplyPointId] as const,
};

export const productQueries = {
  variants: () =>
    queryOptions({
      queryKey: productQueryKeys.variants(),
      queryFn: () => ProductService.getVariants(),
    }),

  products: (supplyPointId: number) =>
    queryOptions({
      queryKey: productQueryKeys.products(supplyPointId),
      queryFn: () => ProductService.getProducts(supplyPointId),
    }),
};
